module.exports = __webpack_public_path__ + "static/0093-4310c4c1678378c80f924d037f3b3161.png";